const headers = {
  name: "Billings",
  navigate: {
    path: [
      {
        name: "Billings",
        path: "/app/billing",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
